<div class="login-page">
    <div class="glow glow-top"></div>
    <div class="glow glow-bottom"></div>

    <main class="login-card">
        <div class="brand">
            <div class="brand-icon">
                <span class="material-symbols-outlined">inventory_2</span>
            </div>
            <h1 class="title">Avesta Package</h1>
            <p class="subtitle">เข้าสู่ระบบด้วยบัญชี Active Directory</p>
        </div>

        <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
            <div class="field">
                <label for="username">ชื่อผู้ใช้ (AD)</label>
                <div class="input-wrap">
                    <input id="username" type="text" formControlName="username" placeholder="เช่น jdoe"
                        autocomplete="username" autocapitalize="off" spellcheck="false" autofocus>
                    <span class="material-symbols-outlined input-icon">person</span>
                </div>
            </div>

            <div class="field">
                <label for="password">รหัสผ่าน</label>
                <div class="input-wrap">
                    <input id="password" class="has-toggle" [type]="showPassword ? 'text' : 'password'"
                        formControlName="password" autocomplete="current-password">
                    <button type="button" class="toggle" (click)="showPassword = !showPassword"
                        [attr.aria-label]="showPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'">
                        <span class="material-symbols-outlined">
                            {{ showPassword ? 'visibility' : 'visibility_off' }}
                        </span>
                    </button>
                </div>
            </div>

            <div class="login-error" [class.retryable]="error.retryable" role="alert" *ngIf="error">
                <span class="material-symbols-outlined">error</span>
                <span>{{ error.message }}</span>
            </div>

            <button type="submit" class="submit" [disabled]="loading">
                <span class="spinner-border spinner-border-sm" *ngIf="loading; else label"></span>
                <ng-template #label>เข้าสู่ระบบ</ng-template>
            </button>
        </form>

        <p class="note">ใช้ชื่อผู้ใช้และรหัสผ่านเดียวกับที่ใช้เข้าเครื่องคอมพิวเตอร์ของบริษัท</p>
    </main>
</div>
